import ToggleButtonGroup, {
  ToggleButtonGroupProps
} from '@material-ui/lab/ToggleButtonGroup';
import ToggleButton from '@material-ui/lab/ToggleButton';
import React, { FC, ReactNode, useContext } from 'react';
import { ButtonToggleContext } from '@leuven2030/framework/Button/ButtonToggleProvider';
import tw from 'twin.macro';

const ButtonToggleGroup: FC<
  ToggleButtonGroupProps & {
    items: { label: ReactNode | string; value: string }[];
  }
> = ({ items, ...props }) => {
  const { selected, setSelected } = useContext(ButtonToggleContext);
  return (
    <ToggleButtonGroup
      tw="space-x-0.5 rounded-md overflow-hidden"
      onChange={(e, value) => {
        setSelected(value);
      }}
      {...props}
    >
      {items.map(({ label, value }, index) => {
        const isSelected = selected.includes(value);

        return (
          <ToggleButton
            value={value}
            key={index}
            aria-label="left aligned"
            css={[
              isSelected &&
                tw`bg-primary-500 text-white hover:(bg-primary-500)`,
              !isSelected &&
                tw`bg-primary-100 text-primary-600 hover:bg-primary-200`
            ]}
            tw=" border-none   rounded-none normal-case py-2 px-3"
          >
            {label}
          </ToggleButton>
        );
      })}
    </ToggleButtonGroup>
  );
};

export default ButtonToggleGroup;
